export type InfoCookiesAction =
  | { type: 'SET_IS_FETCHING_COOKIES_CONTENT' }
  | { type: 'SET_FETCH_COOKIES_CONTENT_FAILED' }
  | { type: 'SET_COOKIES_CONTENT', content: Julius.Website.CookiesNotificationViewModel }

export const setIsFetching = (): InfoCookiesAction => ({
  type: 'SET_IS_FETCHING_COOKIES_CONTENT',
});

export const setFetchFailed = (): InfoCookiesAction => ({
  type: 'SET_FETCH_COOKIES_CONTENT_FAILED',
});

export const setContent = (content: Julius.Website.CookiesNotificationViewModel): InfoCookiesAction => ({
  content,
  type: 'SET_COOKIES_CONTENT',
});


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/Redux/actions.tsx